import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { openSnackbar as openGlobalSnackbar } from "../../../reducers/snackbar"
import { selectProfile } from "../../users/reducer"
import {
  TrialFinishedRoadblockDialogData,
  useTrialFinishedDialogUtils,
} from "../components/TrialFinishedRoadblockDialog"
import { openConciergeGreetingRequiredDialog } from "../reducer"
import { selectCRMSettings } from "../reducer"
import { SETTINGS_TABS, createSettingsTabURL } from "../settings"
import { useGlobalCall } from "./GlobalCallProvider"
import { getOutboundCallGateState } from "./conciergeCallingGate"

export function useStartCandidateCall(localSnackbar) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { startCall, isCallActive } = useGlobalCall()
  const crmSettings = useSelector(selectCRMSettings)
  const profile = useSelector(selectProfile)
  const { runOnlyIfSubscribed } = useTrialFinishedDialogUtils()

  function notify(message) {
    if (localSnackbar) {
      localSnackbar(message)
      return
    }
    dispatch(openGlobalSnackbar({ message }))
  }

  function requestCall(candidate, options = {}) {
    runOnlyIfSubscribed(() => {
      if (isCallActive) {
        notify("Finish or end the current call before starting another.")
        return
      }
      if (!candidate?.id) {
        notify("Could not start call for this candidate.")
        return
      }
      if (!candidate?.phone) {
        notify("This candidate does not have a phone number.")
        return
      }
      switch (getOutboundCallGateState(crmSettings, profile)) {
        case "concierge_no_phone":
          navigate(createSettingsTabURL(SETTINGS_TABS.phoneSms))
          return
        case "concierge_no_greeting":
          dispatch(openConciergeGreetingRequiredDialog())
          return
        case "owner_no_phone":
          navigate(
            createSettingsTabURL(SETTINGS_TABS.phoneSms, { focus: "phone" })
          )
          return
        case "ready":
        default:
          startCall(candidate, options)
      }
    }, new TrialFinishedRoadblockDialogData("Making Calls", "Subscribe to make phone calls to your candidates"))
  }

  return { requestCall, isCallActive }
}
